module.exports = __webpack_public_path__ + "media/ensino-medio-integral.feedf880.mp4";